import React from 'react';
import getDepartureCardCopy, { TRAVELLER_STATUS } from '../../utils/getDepartureCardCopy';
import DeparturePricingSummary from './DeparturePricingSummary';

/**
 * Traveller-facing departure status block — guarantee story + capacity (separated).
 */
export default function DepartureTravellerSummary({
	departure,
	title,
	subtitle,
	compact = false,
	className = '',
}) {
	const copy = getDepartureCardCopy(departure);
	const showProgress = !compact
		&& copy.kind !== TRAVELLER_STATUS.OPEN
		&& copy.kind !== TRAVELLER_STATUS.SOLD_OUT
		&& copy.kind !== TRAVELLER_STATUS.CLOSED;

	return (
		<div className={`departure-traveller-summary departure-traveller-summary--${copy.kind} ${className}`.trim()}>
			{(title || subtitle) && (
				<div className="departure-traveller-summary__head">
					{title && <p className="departure-traveller-summary__title">{title}</p>}
					{subtitle && <p className="departure-traveller-summary__subtitle">{subtitle}</p>}
				</div>
			)}

			<p className="departure-traveller-summary__status">
				<span className="departure-traveller-summary__status-dot" aria-hidden="true" />
				{copy.statusLabel}
			</p>

			<p className="departure-traveller-summary__guarantee">{copy.guaranteeMessage}</p>

			{showProgress && (
				<div className="departure-traveller-summary__progress" aria-hidden="true">
					<div className="departure-traveller-summary__progress-bar" style={{ width: `${copy.progress}%` }} />
				</div>
			)}

			{copy.showCapacity && copy.capacityMessage && (
				<div className="departure-traveller-summary__capacity">
					<p>{copy.capacityMessage}</p>
				</div>
			)}

			{copy.canReserve && (
				<DeparturePricingSummary departure={departure} compact className="departure-traveller-summary__pricing" />
			)}
		</div>
	);
}
